import axios from 'axios';

const BASE_URL = process.env.REACT_APP_CONFIG_API;
const API_BASE_URL = `${BASE_URL}/api`;

function attachInstance(params = {}, instance) {
  if (!instance) return params;
  return { ...params, instance };
}

const audioService = {
  async getAudioMessages(languageId, instance) {
    const params = languageId ? { language_id: languageId } : {};
    const response = await axios.get(`${API_BASE_URL}/audio/messages`, { params: attachInstance(params, instance) });
    return response.data;
  },

  async getLanguages(instance) {
    const response = await axios.get(`${API_BASE_URL}/audio/languages`, { params: attachInstance({}, instance) });
    return response.data;
  },

  getAudioFileUrl(filename) {
    return `${API_BASE_URL}/audio/file/${filename}`;
  },

  async generateAudio(audioId, instance) {
    const response = await axios.post(`${API_BASE_URL}/audio/generate/${audioId}`, null, { params: attachInstance({}, instance) });
    return response.data;
  },

  async generateFullMessageAudio(messageId, instance) {
    const response = await axios.post(`${API_BASE_URL}/audio/generate-full/${messageId}`, null, { params: attachInstance({}, instance) });
    return response.data;
  },

  async regenerateMessage(messageId, instance) {
    const response = await axios.post(`${API_BASE_URL}/audio/regenerate/${messageId}`, null, { params: attachInstance({}, instance) });
    return response.data;
  },

  async parseAndInsertMessage(messageId, instance) {
    const response = await axios.post(`${API_BASE_URL}/audio/parse-insert/${messageId}`, null, { params: attachInstance({}, instance) });
    return response.data;
  },

  async getMasterMessages(languageId, instance) {
    const params = languageId ? { language_id: languageId } : {};
    const response = await axios.get(`${API_BASE_URL}/audio/master-messages`, { params: attachInstance(params, instance) });
    return response.data;
  }
};

export default audioService;

